var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.6863 3 9C3 12.3137 5.6863 15 9 15C12.3137 15 15 12.3137 15 9ZM9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9.00001 16.5C4.85787 16.5 1.5 13.1421 1.5 9C1.5 4.85787 4.85787 1.5 9 1.5Z",
  fill: "#A9BBCA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.75 9C12.75 9.41421 12.4142 9.75 12 9.75L6 9.75C5.58579 9.75 5.25 9.41421 5.25 9C5.25 8.58579 5.58579 8.25 6 8.25L12 8.25C12.4142 8.25 12.75 8.58579 12.75 9Z",
  fill: "#A9BBCA"
})));
export default __webpack_public_path__ + "static/media/remove.a127c12a.svg";
export { SvgComponent as ReactComponent };